import {
    SetBoardViewFiltersRequest,
    SetBoardViewFiltersResponse,
} from "@lifeat/shared/task-management/TaskFilterFunctionContracts";
import { userTaskDataCollection } from "@lifeat/shared/task-management/TaskManagementTypes";
import { logError } from "@service/ConsoleLoggerService";
import { FirestoreService } from "@service/FirestoreService";
import { callMonolith } from "@service/ServerlessFunctionsService";
import { FilterService } from "./FilterService";

export function BoardViewFilterService(uid: string): FilterService {
    const firestore = FirestoreService();
    return {
        listenForFilters(callback) {
            return firestore.getDocumentListener(userTaskDataCollection.at(uid).node, (payload) => {
                if (payload.success) {
                    return callback({ success: true, value: payload.value?.selectedFilters?.boardViewFilters });
                }
                return callback({ success: false });
            });
        },
        async setFilters(
            filters: SetBoardViewFiltersRequest["filters"],
        ): Promise<SetBoardViewFiltersResponse["filters"]> {
            try {
                const payload: SetBoardViewFiltersRequest = { filters };
                return (await callMonolith("set-board-view-filters", payload)).filters;
            } catch (err) {
                logError(`Error setting board view filters: ${err}`);
                return null;
            }
        },
    };
}
export type TaskListFilterService = ReturnType<typeof BoardViewFilterService>;
